/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsCenteredTaggedImageViewProps } from '../../../modules/hosports-centered-tagged-image/./hosports-centered-tagged-image';
import TaggedImage from '../../../baseComponents/tagged-image/./tagged-image';
import ScrollFadeIn from '../../../baseComponents/scroll-fade/./scroll-fade';

export default (props: IHosportsCenteredTaggedImageViewProps) => {
  let config = props.config;

  return (
    <ScrollFadeIn>
      <div className="site-gutter medium-padding">
        <div className="max-width-container">
          <TaggedImage
            image={config.image ? config.image.src : undefined}
            height={config.height}
            products={config.products}
            athletes={config.athletes}
            year={config.year}
          />
        </div>
      </div>
    </ScrollFadeIn>
  );
};
